module.exports = __webpack_public_path__ + "static/media/requsetVehicle.7556e471.svg";